import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledRedirect = styled(Link) `
    color: ${props => props.disabled ? props.theme.color.palette.grey[500] : props.theme.color.palette.text.link};
    font-size: ${props => props.size ? props.size : '14px'};
    text-transform: ${props => props.uppercase === 'true' ? 'uppercase' : null};
    font-weight: ${props => props.weight ? props.weight : 400};
    ${props => ({...props.style})}
    &:hover {
        color: ${props => props.theme.color.palette.text.link};
    }
`

export default function Redirect({children, ...props}) {

    if (props.disabled) {
        props.onClick = (e) => e.preventDefault();
    }

    return (
        <StyledRedirect {...props} >
            {children}
        </StyledRedirect>
    )
}